"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query GetVideo($videoId: String!) {\n    getVideo(videoId: $videoId) {\n      videoId\n      name\n      organisationId\n      permissions\n      outputs {\n        outputId\n        notes\n        editor {\n            firstName\n            lastName\n        }  \n        status {\n          name\n          isCustom\n          requiredPermission\n        }\n        videoId\n        aspectRatio\n        latestVersion\n        isMaster\n        readableId\n        versions {\n          versionId\n          versionNumber\n          submittedAt\n          dueDate\n          assetId\n          appliedAddons {\n            BURN_IN_CAPTIONS {\n              value\n              status\n              rejectionReason\n            }\n            SRT_CAPTIONS {\n              value\n              status\n              rejectionReason\n            }\n            CHROMA_KEY {\n              value\n              status\n              rejectionReason\n            }\n            RUSH_EDIT {\n              value\n              status\n              rejectionReason\n            }\n            DURATION {\n              value\n              status\n              rejectionReason\n            }\n          }\n          requestedAddons {\n            BURN_IN_CAPTIONS {\n              value\n              cost\n            }\n            SRT_CAPTIONS {\n              value\n              cost\n            }\n            CHROMA_KEY {\n              value\n              cost\n            }\n            RUSH_EDIT {\n              value\n              status\n              rejectionReason\n              cost\n            }\n            DURATION {\n              value\n              cost\n            }\n          }\n        }\n      }\n    }\n    getProjectForVideo(videoId: $videoId) {\n      videoProjectId\n      name\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var getVideoQuery = (0, _graphqlTag.default)(_templateObject());

var getVideo = function getVideo(videoId) {
  return {
    query: getVideoQuery,
    module: 'video',
    ignoreCache: true,
    buildVariables: function buildVariables() {
      return {
        videoId: videoId
      };
    }
  };
};

var _default = getVideo;
exports.default = _default;